import { CustomComponent } from './CustomComponent'

export default CustomComponent;